import { Datum } from '@/domain/navigation/benachrichtigungen/components/details/shared/Datum';
import { DetailWrapper } from '@/domain/navigation/benachrichtigungen/components/details/shared/DetailWrapper';
import { Dokumente } from '@/domain/navigation/benachrichtigungen/types/Dokumente';
import { managerV1BaseUrl } from '@/utils';

export default function DokumenteDetail({
  benachrichtigung,
}: {
  benachrichtigung: Dokumente;
}) {
  const linkTo = `${managerV1BaseUrl}/secure/v2/in/search.jsf?idMitarbeiter=${benachrichtigung.mitarbeiter.id}&detailPage=dokumente`;

  return (
    <a href={linkTo}>
      <DetailWrapper
        mitarbeiter={benachrichtigung.mitarbeiter}
        content={
          <div className="w-fit h-5 px-2 py-1 bg-primary-orange-O400 rounded-full inline-flex justify-center items-center gap-1">
            <div className="text-center justify-start text-neutrals-N900 text-xs font-semibold  leading-none">
              {benachrichtigung.name}
            </div>
          </div>
        }
        footer={
          <div className="flex gap-1 items-baseline">
            Erstellt am:
            <Datum von={benachrichtigung.erstellungsDatum} />
          </div>
        }
      />
    </a>
  );
}
